
import { defineComponent } from 'vue'
import PreviewImage
  from '@/views/dashboard/data-safe/screen-watermark-edit/_components/watermark-preview/preview-image.vue'
import { PropType } from 'vue/dist/vue'
import { Wmdata } from '@/views/dashboard/data-safe/screen-watermark/screen-watermark.service'

export default defineComponent({
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    wmdata: {
      type: Object as PropType<Wmdata>,
      default: () => ({}),
    },
  },

  components: {
    PreviewImage
  },

  setup (props, context) {
    function handleClose () {
      context.emit('update:modelValue', false)
    }

    return {
      handleClose,
    }
  }
})
